import { Switch, Route } from 'react-router-dom';

import { Page } from 'components';
import DashboardOverview from './DashboardOverview';
import DashboardWorkInProgress from './DashboardWorkInProgress';
import DashboardSinglePageContainer from './DashboardSinglePageContainer';
import DashboardContracts from './DashboardContracts';
import DashboardFollowing from './DashboardFollowing';
import DashboardSubmitted from './DashboardSubmitted';
import DashboardAwarded from './DashboardAwarded';
import DashboardMissed from './DashboardMissed';

const Dashboard = () => (
  <Page isTinted>
    <Switch>
      <Route path="/dashboard/:page" exact>
        <DashboardSinglePageContainer>
          <Switch>
            <Route path="/dashboard/wip" exact component={DashboardWorkInProgress} />
            <Route path="/dashboard/contracts" exact component={DashboardContracts} />
            <Route path="/dashboard/following" exact component={DashboardFollowing} />
            <Route path="/dashboard/submitted" exact component={DashboardSubmitted} />
            <Route path="/dashboard/awarded" exact component={DashboardAwarded} />
            <Route path="/dashboard/missed" exact component={DashboardMissed} />
          </Switch>
        </DashboardSinglePageContainer>
      </Route>
      <Route path="/dashboard" component={DashboardOverview} />
    </Switch>
  </Page>
);

export default Dashboard;
